
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiBuoySphericalXShape as ObiBuoySphericalXShapeElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-buoy-spherical-x-shape.js';
 
 
 

 
 export const ObiBuoySphericalXShape = createComponent({
   react: React,
   tagName: 'obi-buoy-spherical-x-shape',
   elementClass: ObiBuoySphericalXShapeElement,
   events: {
     
   }
  });
 
 